<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="応募者管理＿テンプレート設定"
      />
      <div class="grid-x align-justify">
        <div class="medium-6 cell">
          <p>応募者へのメッセージ作成画面で使用するテンプレートを設定します。</p>
        </div>
        <div class="medium-6 cell">
          <button
            class="float-right boss-button boss-button-new"
            @click="$router.push({ name: 'settingMessageTemplateRegister' })"
          >
            <span class="boss-icon-new" />
            <span class="boss-button-new-text">テンプレートを追加する</span>
          </button>
        </div>
      </div>
      <table
        v-if="templates.length > 0"
        class="unstriped hover boss-table"
      >
        <thead>
          <tr>
            <th class="boss-table-head-center">
              テンプレート名
            </th>
            <th class="boss-table-head-center">
              件名
            </th>
            <th class="boss-table-head-center boss-update">
              最終更新者
            </th>
            <th class="boss-table-head-center boss-operation">
              編集
            </th>
            <th class="boss-table-head-center boss-copy">
              コピー
            </th>
            <th class="boss-table-head-center boss-operation">
              削除
            </th>
            <th class="boss-table-head-center boss-display-change">
              <div class="pega-setting-templates-relative">
                テンプレートへの表示/非表示
                <span
                  v-tooltip="{ content: '非表示にすると「テンプレート」に反映されません'}"
                  class="pega-circle small-right-top"
                >?</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(template, i) in templates"
            :key="i"
          >
            <td
              class="boss-table-data"
              data-test="template-name"
            >
              {{ template.name }}
            </td>
            <td
              class="boss-table-data pega-subject-label"
              data-test="template-subject"
            >
              {{ template.subject }}
            </td>
            <td
              class="boss-table-data"
              data-test="template-modified"
            >
              {{ template.modified }}
            </td>
            <td class="boss-table-data">
              <button
                class="boss-icon-pencil"
                data-test="template-edit"
                @click="$router.push({ name: 'settingMessageTemplateEdit', params: { id: template.id }})"
              />
            </td>
            <td class="boss-table-data">
              <div
                data-test="template-copy"
                @click="doCopy(template.id)"
              >
                <span class="boss-icon boss-icon-copy-regular boss-icon-copy" />
              </div>
            </td>
            <td
              class="boss-table-data"
              data-test="template-remove"
              @click="doRemove(template.id)"
            >
              <button class="boss-icon-trash" />
            </td>
            <td class="boss-table-data">
              <div class="switch toggle-switch">
                <input
                  :id="`toggle-${template.id}`"
                  data-test="template-display"
                  class="toggle-input"
                  type="checkbox"
                  :checked="template.isDisplayed"
                  @change="changeDisplay(template.id, template.isDisplayed)"
                >
                <label
                  :for="`toggle-${template.id}`"
                  class="toggle-label"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-else
        class="grid-x grid-margin-y align-center margin-top-2"
      >
        <span class="cell medium-4 subheader">テンプレートが作成されていません。</span>
      </div>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import Indicator from '@/lib/indicator'

export default {
  components: {
    SettingHeader
  },
  data () {
    return {
      templates: []
    }
  },
  created () {
    this.fetchTemplates()
      .then(response => this.setProperty(response))
  },
  methods: {
    fetchTemplates () {
      return this.$http.secured.get('/company/entry/message/templates')
    },
    removeTemplate (id) {
      return this.$http.secured.delete(`/company/entry/message/templates/${id}`)
    },
    setProperty (response) {
      this.$set(this, 'templates', response.data)
    },
    doRemove (id) {
      this.$dialog.confirm('削除しますか？')
        // はいを押下した時
        .then(() => {
          this.removeTemplate(id) // 削除して
            .then(() => {
              Indicator.emitShow()
              this.$toasted.global.success({ message: 'テンプレートを削除しました' })
              this.fetchTemplates() // 一覧情報を取り直す
                .then(response => this.setProperty(response))
                .finally(() => {
                  Indicator.emitHide()
                })
            })
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    },
    doCopy (id) {
      this.$http.secured.post(`/company/entry/message/templates/${id}/_copy`).then(() => {
        this.$toasted.global.success({ message: 'テンプレートをコピーしました' })
        this.fetchTemplates().then(response => this.setProperty(response))
      })
    },
    changeDisplay (id, isDisplayed) {
      this.$http.secured.put(`/company/entry/message/templates/${id}/display`, {
        isDisplayed: !isDisplayed
      }).then(response => {
        this.$set(this.templates, this.templates.findIndex((template) => template.id === response.data.id), response.data)
      })
    }
  }
}
</script>
